"use client";

import { useSyncExternalStore } from "react";

/**
 * Whether this deployment renders the V2 theme, read on the client.
 *
 * The value is `AKILI_AUTH_THEME_V2`, parsed server-side by
 * `lib/auth-theme.ts`'s `authThemeV2Enabled()` and published at request
 * time on `window.__PUBLIC_CONFIG__.authThemeV2` (app/(site)/layout.tsx) —
 * the same runtime bridge as the other per-deployment values, so flipping
 * the flag needs no rebuild. Absent bridge (SSR, tests) reads as off.
 */
export function readAuthThemeV2(): boolean {
  return (typeof window !== "undefined" ? window.__PUBLIC_CONFIG__?.authThemeV2 : undefined) === true;
}

const subscribe = () => () => {};

/**
 * `readAuthThemeV2()` as a hook for client components that also render on
 * the server: the server snapshot is `false`, so hydration matches and the
 * client re-renders with the published value.
 */
export function useAuthThemeV2(): boolean {
  return useSyncExternalStore(subscribe, readAuthThemeV2, () => false);
}
